/**
* @author XuZiYu
* @date 2019/7/9
* @time 19:39
*/
<template>
    <div class="login-ms-wrapper">
        <template>
            <div class="header" :style="{'padding-top':headHeight + 'px'}">
                <div class="header-left" @click="goBack"><img src="../../assets/vip/icon_back1.png" alt=""/></div>
                <div class="header-main">成为会员</div>
                <div class="header-right"></div>
            </div>
            <div class="header-pre" :style="{'padding-top':headHeight + 'px'}"></div>
        </template>

        <div class="main">
            <img class="img" src="../../assets/vip/icon_vip@2x.png" alt="">
            <p class="p" v-if="flag === '1'">恭喜您成为VIP题库会员</p>
            <p class="p" v-if="flag === '2'">恭喜您成为教学视频VIP会员</p>
            <p class="p" v-if="flag === '3'">恭喜您成为考场视频VIP会员</p>
        </div>

        <div class="footer">
            <div class="btn-login" @click="goLogin">会员登陆</div>
            <p class="p">为了保障您的会员权益 <br/> 同时享受会员服务，请进行会员登录</p>
        </div>

    </div>
</template>

<script>
export default {
    name: 'vipPayResult',
    data () {
        return {
            flag: ''
        }
    },
    methods: {
        // 返回
        goBack () {
            this.$jsBridge.callBackHandler('returnLastPage')
        },
        goLogin () {
            // 唤起登陆
            this.$jsBridge.callBackHandler('loginUser')
        }
    },
    created () {
        this.flag = this.$route.query.flag
    }
}
</script>

<style scoped lang="scss">
    .login-ms-wrapper{

        .main{
            margin-top: 85px;
            text-align: center;
            .img{
                width: 72px;
            }
            .p{
                margin-top: 15px;
                font:600 18px PingFangSC-Semibold,PingFang SC;
                color:rgba(51,51,51,1);
            }
        }

        .footer{
            .btn-login{
                margin: 115px auto 0;
                display: flex;
                align-items: center;
                justify-content: center;
                width:325px;
                height:43px;
                background:rgba(245,221,182,1);
                border-radius:21.5px;
                font:600 18px PingFangSC-Semibold,PingFang SC;
                color:rgba(168,111,47,1);
            }
            .p{
                margin-top: 20px;
                text-align: center;
                font:400 12px PingFangSC-Regular,PingFang SC;
                color:rgba(153,153,153,1);
            }
        }
    }
    .header{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        z-index: 9999;
        justify-content: space-between;
        height: 60px;
        background: #ffffff;
        .header-main{
            font-size:18px;
            font-weight:bold;
            color: #333333;
        }
        .header-left,.header-right{
            display: flex;
            padding: 15px 10px;
            font-size: 0;
            line-height: 1;
            width: 24px;
            img{
                width: 24px;
                height: 24px;
            }
        }
    }
    .header-pre{
        height: 60px;
    }

</style>
